import React from "react";
import { Box, Button as MUIButton, SxProps, Typography } from "@mui/material";
import { commonStyles } from "./commonStyles";
import Loader from "./Loader";

interface ButtonProps {
  text: string;
  isLoading?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  fullWidth?: boolean;
  size?: "small" | "medium" | "large";
  additionalSx?: SxProps;
  errorText?: string;
}

const Button: React.FC<ButtonProps> = ({
  text,
  isLoading = false,
  disabled,
  fullWidth = false,
  size = "medium",
  additionalSx,
  errorText,
  ...props
}) => {
  return (
    <Box
      sx={{
        width: fullWidth ? "100%" : "auto",
        position: "relative",
        ...additionalSx,
      }}
    >
      <Typography
        sx={{
          color: commonStyles.errorRed,
          fontSize: commonStyles.fontSizes.small,
          position: "absolute",
          top: -22,
          ml: 1,
        }}
      >
        {errorText}
      </Typography>
      <MUIButton
        variant="contained"
        disabled={disabled || isLoading}
        sx={{
          width: fullWidth ? "100%" : "auto",
          height:
            size === "small" ? "40px" : size === "large" ? "60px" : "50px",
          p: 3,
          borderRadius: 2,
          backgroundColor: commonStyles.cpaGold,
          color: "white",
          fontSize: size === "small" ? 12 : size === "large" ? 20 : 16,
          fontWeight: "bold",
          "&.Mui-disabled": {
            backgroundColor: commonStyles.cpaGold,
          },
          boxShadow: "none",
        }}
        {...props}
      >
        {isLoading ? <Loader isWhite /> : text}
      </MUIButton>
    </Box>
  );
};

export default Button;
